export const POST_LOG_ITEM = {
    REQUEST: 'POST_LOG_ITEM_REQUEST',
    SUCCESS: 'POST_LOG_ITEM_SUCCESS',
    FAILED: 'POST_LOG_ITEM_FAILED',
    ERROR: 'POST_LOG_ITEM_ERROR'
};

export const GET_PUSHER_COMMENT = "GET_PUSHER_COMMENT";
export const GET_PUSHER_COMMENT_ITEM = "GET_PUSHER_COMMENT_ITEM";
export const CHANGE_ORDER_ITEM_QUANTITY = "CHANGE_ORDER_ITEM_QUANTITY";